import { useEffect } from "react";

const PLAUSIBLE = process.env.REACT_APP_PLAUSIBLE_DOMAIN || "";
const GA4 = process.env.REACT_APP_GA4_ID || "";

/**
 * Charge Plausible et/ou GA4 une seule fois (env optionnels).
 */
export default function Analytics() {
    useEffect(() => {
        if (PLAUSIBLE && !document.getElementById("plausible-script")) {
            const s = document.createElement("script");
            s.id = "plausible-script";
            s.defer = true;
            s.setAttribute("data-domain", PLAUSIBLE);
            s.src = "https://plausible.io/js/script.js";
            document.head.appendChild(s);
        }

        if (GA4 && !document.getElementById("ga4-script")) {
            const s = document.createElement("script");
            s.id = "ga4-script";
            s.async = true;
            s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4}`;
            document.head.appendChild(s);

            window.dataLayer = window.dataLayer || [];
            function gtag() {
                window.dataLayer.push(arguments);
            }
            window.gtag = gtag;
            gtag("js", new Date());
            gtag("config", GA4, { anonymize_ip: true });
        }
    }, []);

    return null;
}
